import { render, staticRenderFns } from "./ViewProjectsSubmitted.vue?vue&type=template&id=a2ebe7b6&scoped=true&"
import script from "./ViewProjectsSubmitted.vue?vue&type=script&lang=ts&"
export * from "./ViewProjectsSubmitted.vue?vue&type=script&lang=ts&"
import style0 from "./ViewProjectsSubmitted.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewProjectsSubmitted.vue?vue&type=style&index=1&id=a2ebe7b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ebe7b6",
  null
  
)

component.options.__file = "ViewProjectsSubmitted.vue"
export default component.exports